export default "__VITE_ASSET__2bda561c__"